export const EndDate = 'end';
export const Entitlement = 'entitlement';
export const WeekendsIncluded = 'weekendsIncluded';
export const ManagerEmail = 'managerEmail';
export const ManagerName = 'managerName';
export const KnownAsName = 'knownAsName';
export const CountryCode = 'countryCode';
export const RegionCode = 'regionCode';
export const ManagerSharingDataOption = 'managerSharingDataOption';
export const RemainingEntitlement = 'remainingEntitlement';
export const TotalEntitlement = 'totalEntitlement';
export const BankHolidaysDeducting = 'bankHolidaysDeducting';
export const RequestManager = 'requestManager';
export const ManagerEmailConfirmation = 'managerEmailConfirmation';
